import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '../i18n/lang-route-i18n';

export function langRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}`;
}
